import moment from 'moment';

Vue.component('performance', {
    data () {
        return {
            filter: {
                from: moment().startOf('month').format("DD-MM-YYYY"),
                to: moment().endOf('month').format("DD-MM-YYYY"),
            },

            filterBy: 'updated_at',

            loading: false,

            performanceData: [],
        }
    },

    mounted () {
        this.fetchData();
    },

    methods: {
        handleFilterDateSelected (field, value) {
            this.filter[field] = value;

            this.fetchData();
        },

        setFilterBy (filterBy) {
            this.filterBy = filterBy;

            this.fetchData();
        },

        fetchData () {
            this.loading = true;

            axios.get('/admin/performance/data', {
                params: {
                    from: this.filter.from,
                    to: this.filter.to,
                    filter_by: this.filterBy,
                }
            }).then((response) => {
                this.loading = false;
                this.performanceData = response.data;
            });
        },
    }
});

Vue.component('performance-graph', {
    props: ['performance-data'],

    data () {
        return {
            width: 1000
        }
    },

    template: `<div>
      <div v-if="this.width !== undefined" :style="{width: this.width + 'px' }" style="position: relative; height: 600px; padding-left: 88px;"><canvas class="chart" id="performance-chart"></canvas></div>
    </div>`,

    mounted () {
        const labels = this.performanceData.map(c => c.name);

        this.width = (this.performanceData.length * 174) + 124;

        new Chart($('#performance-chart'), {
            type: 'bar',
            data: {
                labels,
                datasets: [
                    {
                        stacked: true,
                        label: 'Appointments',
                        backgroundColor: '#63c2de',
                        data: this.performanceData.map(c => c.graph_data.appointments)
                    },
                    {
                        stacked: true,
                        label: 'Reschedules',
                        backgroundColor: '#ffc107',
                        data: this.performanceData.map(c => c.graph_data.rescheduled)
                    },
                    {
                        stacked: true,
                        label: 'Cancelled',
                        backgroundColor: '#fc5203',
                        data: this.performanceData.map(c => c.graph_data.cancelled)
                    },
                    {
                        stacked: true,
                        label: 'Completed',
                        backgroundColor: '#28a745',
                        data: this.performanceData.map(c => c.graph_data.completed)
                    },
                    {
                        stacked: true,
                        label: 'Sales',
                        backgroundColor: '#17a2b8',
                        data: this.performanceData.map(c => c.graph_data.sales)
                    },
                    {
                        stacked: true,
                        label: 'Quotes',
                        backgroundColor: '#7952b3',
                        data: this.performanceData.map(c => c.quote)
                    },
                ],
            },
            options: {
                scales: {
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            fontColor: "white",
                        }
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                },
                responsive: true,
                maintainAspectRatio: false,
            }
        });
    }
});
